import { IS_BROWSER } from "@/lib/browserUtils";

export type ExternalAuthQueryValue = string | null | undefined | Array<string | null>;
export type ExternalAuthQuery = Record<string, ExternalAuthQueryValue>;

declare global {
  interface Window {
    TWTRAuthFlowHandler?: (data: ExternalAuthQuery | null) => void;
  }
}

export async function executeAndUpdate<T>(
  getAuthUrl: () => Promise<string>,
  onRedirect: (query: ExternalAuthQuery) => Promise<T>
): Promise<T | null> {
  if (!IS_BROWSER) {
    return null;
  }

  const authUrl = await getAuthUrl();

  const authData = await new Promise<ExternalAuthQuery | null>((resolve, reject) => {
    let finished = false;
    let popup: Window | null = null;
    let checkClosedIntervalId: number | null = null;

    const finish = (data: ExternalAuthQuery | null) => {
      if (finished) {
        return;
      }
      finished = true;
      if (checkClosedIntervalId !== null) {
        window.clearInterval(checkClosedIntervalId);
      }
      delete window.TWTRAuthFlowHandler;
      resolve(data);
    };

    checkClosedIntervalId = window.setInterval(() => {
      if (popup?.closed) {
        finish(null);
      }
    }, 300);

    window.TWTRAuthFlowHandler = finish;

    popup = window.open(authUrl, "_blank", "popup=yes,width=600,height=700");

    if (!popup) {
      window.clearInterval(checkClosedIntervalId);
      delete window.TWTRAuthFlowHandler;
      reject(new Error("Cannot open auth popup"));
    }
  });

  if (!authData) {
    return null;
  }

  return onRedirect(authData);
}

export default {
  executeAndUpdate,
};
